

async function openDb() {
	return new Promise((resolve, reject) => {

		let request = window.indexedDB.open("mindfuleatingapp", 1);

		request.onerror = e => {
			console.log('Error opening db', e);
			reject('Error');
		};

		request.onsuccess = e => {
			resolve(e.target.result);
		};

		request.onupgradeneeded = e => {
			console.log('onupgradeneeded');
			let db = e.target.result;
			let objectStore = db.createObjectStore("meals", { autoIncrement: true, keyPath: 'id' });
			objectStore.createIndex("eatingTime", "eatingTime", { unique: false });
		};
	});
}

async function addMeal(meal) {
	let db = await openDb()
	return new Promise((resolve, reject) => {

		let trans = db.transaction(['meals'], 'readwrite');

		// eslint-disable-next-line no-unused-vars
		trans.oncomplete = e => {
			resolve();
		};

		trans.onerror = e => {
			console.log('Error opening db', e);
			reject('Error');
		};

		let store = trans.objectStore('meals');
		store.add(meal);

	});
}

async function updateMeal(meal) {
	let db = await openDb()
	return new Promise((resolve, reject) => {

		let trans = db.transaction(['meals'], 'readwrite');

		// eslint-disable-next-line no-unused-vars
		trans.oncomplete = e => {
			resolve();
		};

		trans.onerror = e => {
			console.log('Error updating meal', e);
			reject('Error');
		};

		let store = trans.objectStore('meals');
		store.put(meal);

	});
}

async function getMeal(id) {

	let db = await openDb()
	return new Promise((resolve, reject) => {

		let trans = db.transaction(['meals'], 'readonly');
		var meal = null
		// eslint-disable-next-line no-unused-vars
		trans.oncomplete = e => {
			resolve(meal);
		};

		trans.onerror = e => {
			console.log('Error getting meal', e);
			reject('Error');
		};

		let store = trans.objectStore('meals');
		var objectStoreRequest = store.get(parseInt(id));

		// eslint-disable-next-line no-unused-vars
		objectStoreRequest.onsuccess = function (event) {
			meal = objectStoreRequest.result;
		};
	});
}

async function deleteMeal(id) {

	let db = await openDb()
	return new Promise((resolve, reject) => {

		let trans = db.transaction(['meals'], 'readwrite');
		// eslint-disable-next-line no-unused-vars
		trans.oncomplete = e => {
			resolve();
		};

		trans.onerror = e => {
			console.log('Error getting meal', e);
			reject('Error');
		};

		let store = trans.objectStore('meals');
		store.delete(parseInt(id));
	});
}

async function getMealsDesc() {
	let db = await openDb()
	return new Promise((resolve, reject) => {
		let meals = [];
		let trans = db.transaction(['meals'], 'readonly');
		trans.oncomplete = e => {
			console.log('Success reading meals', e);
			resolve(meals);
		};

		let store = trans.objectStore('meals');

		var index = store.index('eatingTime');
		let cursor = index.openCursor(null, "prev");
		cursor.onsuccess = e => {
			let cursor = e.target.result;
			if (cursor) {
				meals.push(cursor.value)
				cursor.continue();
			}
		};

		cursor.onerror = e => {
			console.log('Error reading meals', e);
			reject('Error');
		};

	});
}

export default { addMeal, getMealsDesc, getMeal, updateMeal, deleteMeal}